import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { colDefs, rowData } from './tables/as568-orings';
import { faFileInvoice, faBookOpen, faChartBar, faEnvelope } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-o-ring-size-chart-as568',
    templateUrl: './o-ring-size-chart-as568.component.html',
    styleUrls: [
        '../m3-shared-sizechart.scss',
        './o-ring-size-chart-as568.component.scss'
    ],
    standalone: false
})
export class ORingSizeChartAs568Component {
  rowData = rowData;
  colDefs = colDefs;

  faFileInvoice = faFileInvoice;
  faBookOpen = faBookOpen;
  faChartBar = faChartBar;
  faEnvelope = faEnvelope;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private meta: Meta,
    private title: Title,
  ) {
    this.meta.updateTag({name: "search-title", class: "swiftype", content: "USA O-ring Size Chart (AS568)", "data-type": "string"});
    this.title.setTitle(`AS568 O-Ring Size Chart | Marco Sealing Solutions`);
  }

  isBrowser() {
    return isPlatformBrowser(this.platformId);
  }
}
